var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "title" }, [_vm._v("脏腑气血")]),
      _c("div", { staticClass: "pulseDetail" }, [
        _c("div", {
          staticStyle: { width: "950px", height: "600px" },
          attrs: { id: "pulseChart" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }